import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { Toaster } from 'sonner';
import App from './App.tsx';
import './index.css';
import { setupGlobalMonitoring } from './lib/monitoring';

setupGlobalMonitoring();

// Restore custom favicon from localStorage on boot
(() => {
  const storedLogo = localStorage.getItem('@helps:logo');
  if (storedLogo) {
    const link = document.getElementById('app-favicon') as HTMLLinkElement | null;
    if (link) {
      link.type = 'image/png';
      link.href = storedLogo;
    }
  }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <>
      <App />
      <Toaster richColors position="top-right" />
    </>
  </StrictMode>,
);
